import { NgModule } from '@angular/core';
import { PrimeModule } from 'src/app/shared/modules/prime.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { CustomFieldsetComponent } from './custom-fieldset.component';

@NgModule({
    imports: [
        PrimeModule,
        PipesModule
    ],
    declarations: [
        CustomFieldsetComponent
    ],
    exports: [
        CustomFieldsetComponent
    ]
})
export class CustomFieldsetModule { }
